import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { ROLES } from '@/config'

/**
 * Utente corrente. Popolato dalla guard del router al primo accesso
 * e svuotato al logout: le pagine lo leggono, non lo ricaricano.
 */
export const useUserStore = defineStore('user', () => {
  const user = ref(null)

  const isLogged = computed(() => !!user.value)
  const roles = computed(() => user.value?.roles ?? [])
  const isAdmin = computed(() => roles.value.includes(ROLES.ADMIN))

  function setUser(userData) {
    user.value = userData
  }

  function clearUser() {
    user.value = null
  }

  /** Vero se l'utente ha almeno uno dei ruoli richiesti (o se non ne serve nessuno). */
  function hasRole(required) {
    if (!required?.length) return true
    return required.some((role) => roles.value.includes(role))
  }

  return { user, isLogged, roles, isAdmin, setUser, clearUser, hasRole }
})
